import api from "../../client";
import { AccountVisibilityResponseData } from "../../types/account";
import { AccountVisibility } from "../../types/people";

export const updateAccountVisibilityRequest = async (
  id: string,
  visibility: AccountVisibility,
): Promise<AccountVisibilityResponseData> => {
  const { data } = await api.put<AccountVisibilityResponseData>(
    `/profile/account-visibility/${id}`,
    { visibility },
  );

  return data;
};
